var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermostat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 13V5C15.6001 3.34 14.2601 2 12.6001 2C10.9401 2 9.6001 3.34 9.6001 5V13C8.3901 13.91 7.6001 15.37 7.6001 17C7.6001 19.76 9.8401 22 12.6001 22C15.3601 22 17.6001 19.76 17.6001 17C17.6001 15.37 16.8101 13.91 15.6001 13ZM11.6001 11V5C11.6001 4.45 12.0501 4 12.6001 4C13.1501 4 13.6001 4.45 13.6001 5V6H12.6001V7H13.6001V8V9H12.6001V10H13.6001V11H11.6001Z",
    fill: "#28B178"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/thermostat.cffcdeb57c69ef1c857d0a100f5e3c06.svg";
export { ForwardRef as ReactComponent };